import * as station from '../actions/stationQueryAction'

const initialState = {
//    stationId: undefined,
//    record: { devices: [], inverters: []},
//    error: undefined,
//    status: 0
};

const stationRecord = (state = initialState, action) => {

//    console.log(state, action);
    switch (action.type) {
        case station.STATION_RECORD_REQUEST:
            if (state[action.stationId]) {
                state[action.stationId] = {
                    ...state[action.stationId],
                    error: undefined,
                    status: 1
                }
            } else {
                state[action.stationId] = {
                    stationId: action.stationId,
                    record: { devices: [], inverters: []},
                    error: undefined,
                    status: 1
                }
            }
            return (state);

        case station.STATION_RECORD_SUCCESS:
            state[action.stationId] = {
                stationId: action.stationId,
                record: action.record,
                error: undefined,
                status: 2
            }
            return (state);

        case station.STATION_RECORD_FAILURE:
            state[action.stationId] = {
                ...state[action.stationId],
                error: action.error,
                status: 3
            }            
            return (state);

        default:
            return (state);
    };
}

export default stationRecord;
